import { c as _c } from "react/compiler-runtime";
import { Link } from '@/components/links';
import ChevronRightIcon from '@/assets/icons/heroIcons/Chevron-right.svg';
import { logEvent } from '@/analytics/events';
export type LinkQuestionProps = {
  title: string;
  slug: string;
};
export function LinkQuestion(props) {
  const $ = _c(9);
  const t0 = `linkQuestion${props.slug}`;
  const t1 = `linkQuestion${props.slug}`;
  let t2;
  if ($[0] !== props.title) {
    t2 = () => logEvent("select_faq", {
      action: props.title
    });
    $[0] = props.title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ChevronRightIcon className="ml-auto min-h-[24px] min-w-[24px] text-blue-500 md:h-10 md:w-10" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== props.slug || $[4] !== props.title || $[5] !== t0 || $[6] !== t1 || $[7] !== t2) {
    t4 = <Link analyticsParam={t0} testId={t1} to={props.slug} onClick={t2} className="hover:shadow-card flex items-center rounded-2xl bg-white p-4 text-sm font-semibold text-gray-900 no-underline transition-shadow md:p-6 md:text-xl">{props.title}{t3}</Link>;
    $[3] = props.slug;
    $[4] = props.title;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}